module.exports = __webpack_public_path__ + "static/media/logo.f58e7489.jpg";